export class EngineHomeCpnt {
    
    constructor()
    {
        this.initializeEngineHome();
    }
    
    initializeEngineHome()
    {
        let $engine       = $( '[data-engine-home]' ),
            $engineSelect = $( '[data-engine-home-select]' ),
            $form         = $( '[data-engine-form]' ),
            $engineTab    = $( '[data-engine-tab-item]' ),
            showEngine    = '[data-show-engine]',
            closeEngine   = '[data-close-engine]';
        
        if ( $( '.home' ).length > 0  && $engine.length > 0  & $engineSelect.length > 0) {
            
            $( document ).on( 'click', showEngine, function () {
                $( 'body' ).addClass( 'engineModalOpen' );
            } );
            
            $( document ).on( 'click', closeEngine, function () {
                $( 'body' ).removeClass( 'engineModalOpen' );
            } );
            
            $( document ).on( 'click', '[data-engine-tab-item]', function () {
                $('.nbPers').hide();
                let type = $( this ).attr( 'id' );
                if ( $engine.attr( 'data-current' ) != type ) {
                    
                    $( '[data-engine-tab-item]' ).removeClass( 'active' );
                    $( this ).addClass( 'active' );
                    
                    $.ajax( {
                                url: Theme.getSelectEngineHome,
                                method: "POST",
                                data: {
                                    'type': type,
                                },
                            } ).done( function ( data ) {
                        
                        $engine.attr( 'data-current', type );
                        $engineSelect.html( data.result );
                        let url = $engineSelect.find( 'option:selected' ).attr( 'rel' );
                        let nbpers = $engineSelect.find('option:selected').attr( 'data-pers' );
                        if(nbpers == 1) {
                            $('.nbPers').show();
                        } else {
                            $('.nbPers').hide();
                        }
                        $form.attr( 'action', url );
                        
                    } );
                    
                }
                
            } );
            
            // Change action form
            $engineSelect.on( 'change', function () {
                let url = $( this ).find( 'option:selected' ).attr( 'rel' );
                let nbpers = $( this ).find( 'option:selected' ).attr( 'data-pers' );
                if(nbpers == 1) {
                    $('.nbPers').show();
                } else {
                    $('.nbPers').hide();
                }
                $form.attr( 'action', url );
            } );
            
            // code js qui permet de genere les calendriers
            let date      = new Date();
            let $inputfin = $( '#dateend' ).pickadate( {
                                                           min: date,
                                                           container: '.wrapper'
                                                       } );
            let $inputdeb = $( '#datestart' ).pickadate( {
                                                             min: date,
                                                             container: '.wrapper',
                                                             onSet: function ( date ) {
                                                                 date           = new Date( date.select );
                                                                 let picker_fin = $inputfin.pickadate( 'picker' );
                                                                 picker_fin.set( 'min', date );
                                                                 date.setDate( date.getDate() + 7 );
                                                                 picker_fin.set( 'select', date );
                                                             }
                                                         } );
            $( '#dateend' ).on( 'click', function () {
                if ( $( '#datestart' ).val() != '' ) {
                    $inputfin.pickadate( 'picker' ).set( 'min', $( '#datestart' ).val() );
                }
            } );
            
            $engine.find( 'input[type=submit]' ).on( 'click', function ( e ) {
                
                let pickerdeb = $inputdeb.pickadate( 'picker' );
                let pickerend = $inputfin.pickadate( 'picker' );
                
                let datedeb = pickerdeb.get( 'select' );
                let datefin = pickerend.get( 'select' );
                
                if ( datedeb !== null && datefin !== null && typeof datedeb.obj != 'undefined' && typeof datefin.obj != 'undefined' ) {
                    
                    let timeDiff = Math.abs( datefin.obj.getTime() - datedeb.obj.getTime() );
                    let diffDays = Math.ceil( timeDiff / (
                        1000 * 3600 * 24
                    ) );
                    if ( diffDays == 0 ) {
                        diffDays = 1;
                    }
                    $( '.engineBookingForm [name="marketplace_search[duration]"]' ).val( diffDays );
                }
                
                $engine.validationEngine( 'attach', {
                    promptPosition: "topLeft",
                    scroll: false
                } );
                
                if ( $engine.validationEngine( 'validate' ) == true ) {
                    $form.submit();
                }
                e.preventDefault();
                return false;
            } );
        }
        
    }
}